import React, { useState, useEffect } from "react";
import {
  History,
  Copy,
  Eye,
  Calendar,
  Users,
  DollarSign,
  MapPin,
  ChevronDown,
  ChevronRight,
  IndianRupee,
} from "lucide-react";
import ReactMarkdown from "react-markdown";
import graphqlRequest from "../../requestMethod";
import "./PostedJobsHistory.scss";

const PostedJobsHistory = ({ onRepostJob }) => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showJobModal, setShowJobModal] = useState(false);
  const [shifts, setSuggestions] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [previousJobs, setPreviousJobs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let loginData = localStorage.getItem("auth");
        let token = JSON.parse(loginData)?.accessToken;



        const query = `
        query {
          withAuth(token: "${token}") {
            listPostedJobs {
              id
              jobDescription
              createdAt
              additionalSkill {
                id
                name
              }
              
              timingsType
              hospital: branch { id jobLocation { hospitalName } }
              department {id departmentType {id name } }
              qualification: qualification {id name }
              profession: candidateType {id name}
              specialization {id name }
              numExperience {id name }
              rateOffered: minRate
              maxRate
              professionalCount: numberOfJobs
              pocDetails: contactDetail {  contactPerson email phone}
              duration: numberOfDays
              shiftHours
              campDuty: campDuty
              startTime
              isFood
              isAccommodation
              isTransport
              others
              shiftLogs {
                startTime {
                  datetime
                }
              }
            }
          }
        }
      `;

        const data = await graphqlRequest(query);
        const suggestions = data.data?.withAuth?.listPostedJobs || [];
        setPreviousJobs(suggestions);
        // console.log("Fetched suggestions:", suggestions);
        // Normalize the data to your component’s needs
        const normalizedShifts = suggestions.map((job) => ({
          ...job,
          duration: job?.shiftHours,
          professionalCount: job?.professionalCount,
          rateOffered: job?.maxRate,
          campDuty: job?.campDuty,
          // pocDetails: `${job?.pocDetails?.contactPerson} (${job?.pocDetails?.email}) ${job?.pocDetails?.phone}`,
          hospital: job?.hospital?.id,
          department: job?.department?.id,
          profession: job?.profession?.id,
          qualification: job?.qualification?.id,
          specialization: job?.specialization?.id,
          experience: job?.numExperience?.id,
          jobDescription: job?.jobDescription,
          recurringDays: [],
          hospitalName: job?.hospital?.jobLocation?.hospitalName,
          departmentName: job?.department?.departmentType?.name,
          professionName: job?.profession?.name,
          specializationName: job?.specialization?.name,
          qualificationName: job?.qualification?.name,
          experienceName: job?.numExperience?.name,
          skillSet: job?.additionalSkill,
          shiftType: job?.timingsType === "CONSEQUTIVE" ? "single" : "multiple",
          pocDetails: `${job?.pocDetails?.contactPerson} (${job?.pocDetails?.email}) ${job?.pocDetails?.phone}`,
          isFood: job?.isFood,
          isAccommodation: job?.isAccommodation,
          isTransport: job?.isTransport,
          others: job?.others,
        }));
        console.log("normalizedShifts", normalizedShifts);
        setSuggestions(normalizedShifts);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // const groupedJobs = shifts.reduce((acc, shift) => {
  //   const key = `${shift.hospital}-${shift.department}-${shift.profession}`;
  //   if (!acc[key]) {
  //     acc[key] = [];
  //   }
  //   acc[key].push(shift);
  //   return acc;
  // }, {});

  // const jobGroups = Object.entries(groupedJobs).map(([key, shifts]) => {
  //   const [hospital, department, profession] = key.split("-");
  //   const latestShift = [...shifts].sort(
  //     (a, b) =>
  //       new Date(b.createdAt || 0).getTime() -
  //       new Date(a.createdAt || 0).getTime()
  //   )[0];

  //   console.log("Latest shift for job group:", latestShift);
  //   return {
  //     id: key,
  //     hospital,
  //     department,
  //     profession,
  //     shifts,
  //     latestShift,
  //     totalShifts: shifts.length,
  //     lastPosted: latestShift.createdAt,
  //   };
  // });

  const handleRepost = (job) => {
    console.log("job repost", job);
    const jobData = {
      professionalDetails: {
        hospital: job?.hospital,
        department: job?.department,
        profession: job?.profession,
        qualification: job?.qualification,
        specialization: job?.specialization,
        experience: job?.experience,
        hospitalName: job?.hospitalName,
        departmentName: job?.departmentName,
        professionName: job?.professionName,
        specializationName: job?.specializationName,
        qualificationName: job?.qualificationName,
        experienceName: job?.experienceName,
        skillSet: job?.additionalSkill,
      },

      shiftConfig: {
        duration: job?.shiftHours,
        professionalCount: job?.professionalCount,
        rateOffered: job?.maxRate,
        campDuty: job?.campDuty,
        // pocDetails: job?.pocDetails,
        recurringDays: [],
        shiftType: job?.timingsType === "CONSEQUTIVE" ? "single" : "multiple",
      },

       jobDescription: job?.jobDescription,

      pocFacilities: {
        pocDetails: job?.pocDetails || false,
        isFood: job?.isFood,
        // isAccommodation: job?.isAccommodation,
        isTransport: job?.isTransport || false,
        others: job?.others || '',
      }

      // duration: job?.shiftHours,
      // professionalCount: job?.professionalCount,
      // rateOffered: job?.maxRate,
      // campDuty: job?.campDuty,
      // pocDetails: `${job?.pocDetails?.contactPerson} (${job?.pocDetails?.email}) ${job?.pocDetails?.phone}`,
      // hospital: job?.hospital?.id,
      // department: job?.department?.id,
      // profession: job?.profession?.id,
      // qualification: job?.qualification?.id,
      // specialization: job?.specialization?.id,
      // experience: job?.numExperience?.id,
      // jobDescription: job?.jobDescription,
      // recurringDays: [],
      // hospitalName: job?.hospital?.jobLocation?.hospitalName,
      // departmentName: job?.department?.departmentType?.name,
      // professionName: job?.profession?.name,
      // specializationName: job?.specialization?.name,
      // qualificationName: job?.qualification?.name,
      // experienceName: job?.numExperience?.name,
      // skillSet: job?.additionalSkill,
      // shiftType: job?.timingsType === "CONSEQUTIVE" ? "single" : "multiple",
    };

    onRepostJob(jobData);

    setIsOpen(false);
  };

  // const handleRepost = (job) => {
  //   const jobData = {
  //     professionalDetails: {
  //       hospital: job.hospital,
  //       department: job.department,
  //       profession: job.profession,
  //       qualification: job.latestShift.qualification,
  //       specialization: job.latestShift.specialization,
  //       experience: job.latestShift.experience,
  //     },
  //     shiftConfig: {
  //       shiftType: "multiple",
  //       professionalCount: job.latestShift.professionalCount,
  //       rateOffered: parseFloat(job.latestShift.rateOffered),
  //       campDuty: job.latestShift.campDuty,
  //       pocDetails: job.latestShift.pocDetails,
  //       startDate: new Date().toISOString().split("T")[0],
  //       endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
  //         .toISOString()
  //         .split("T")[0],
  //       startTime: job.latestShift.startTime,
  //       duration: job.latestShift.duration,
  //       recurringDays: ["Mon", "Tue", "Wed", "Thu", "Fri"],
  //     },
  //     jobDescription:
  //       job.latestShift.jobDescription ||
  //       `${job.profession} position in ${job.department} department`,
  //   };

  //   onRepostJob(jobData);
  //   // Show success message here if needed
  // };

  const formatDate = (dateInput) => {
    if (!dateInput) return "Unknown";

    try {
      const date = new Date(Number(dateInput));

      if (isNaN(date.getTime())) return "Invalid Date";

      const options = { month: "short", day: "numeric", year: "numeric" };
      return date.toLocaleDateString("en-US", options);
    } catch {
      return "Unknown";
    }

    // if (!dateInput) return "Unknown";

    // try {
    //   const date = new Date(Number(dateInput));

    //   if (isNaN(date.getTime())) return "Invalid Date";

    //   const day = String(date.getDate()).padStart(2, "0");
    //   const month = String(date.getMonth() + 1).padStart(2, "0");
    //   const year = date.getFullYear();

    //   return `${day}/${month}/${year}`;
    // } catch {
    //   return "Unknown";
    // }
  };

  // console.log("previousJobs", previousJobs.length);

  const openJobModal = (job) => {
    setSelectedJob(job);
    setShowJobModal(true);
    // setIsOpen(false);
    setIsOpen(true);
  };

  if (isLoading) {
    return (
      <div className="posted-jobs-history">
        <button className="history-toggle" disabled>
          <div className="toggle-content">
            <div className="toggle-left">
              <div className="icon-container">
                <History size={18} />
              </div>
              <span>Loading job history...</span>
            </div>
          </div>
        </button>
      </div>
    );
  }

  // console.log("selectedJob", selectedJob);
  

  return (
    // <div className="posted-jobs-history">
    <div className={`posted-jobs-history ${isOpen ? "expanded" : ""}`}>
      <button className="history-toggle" onClick={() => setIsOpen(!isOpen)}>
        <div className="toggle-content">
          <div className="toggle-left">
            <div className="icon-container">
              <History size={18} />
            </div>
            {/* <span>Previously Posted Jobs ({previousJobs?.length || 0})</span> */}
            <span>Previously Posted Jobs</span>
          </div>
          <div className="toggle-icon">
            {isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
          </div>
        </div>
      </button>

      {isOpen && (
        <div className="card-modern history-content">
          <div className="p-6">
            {shifts.length === 0 ? (
              <div className="empty-state">
                <History className="empty-icon" />
                <p className="empty-title">No job history available</p>
                <p className="empty-subtitle">
                  Create your first shift to see posting history here
                </p>
              </div>
            ) : (
              <div className="jobs-list">
                {shifts.map((job) => (
                  <div key={job.id} className="job-card">
                    <div className="job-content">
                      <div className="job-main">
                        <div className="job-header">
                          <h3 className="job-title">
                            {job.specializationName}
                          </h3>
                          {/* <span className="badge badge-secondary">
                            {job.totalShifts} shift
                            {job.totalShifts > 1 ? "s" : ""}
                          </span> */}
                        </div>

                        <div className="job-details">
                          <div className="job-detail">
                            <MapPin className="detail-icon" />
                            <span>{job.hospitalName}</span>
                          </div>
                          <div className="job-detail">
                            {/* <Calendar className="detail-icon" /> */}
                            <span>{job.departmentName}</span>
                          </div>
                          <div className="job-detail">
                            {/* <Calendar className="detail-icon" /> */}
                            <span>{job.professionName}</span>
                          </div>
                          <div className="job-detail">
                            {/* <IndianRupee className="detail-icon" /> */}
                            <span>₹ {job.rateOffered}/hr</span>
                          </div>
                          <div className="job-detail">
                            <Users className="detail-icon" />
                            <span>
                              {job.professionalCount} professional
                              {job.professionalCount > 1 ? "s" : ""}
                            </span>
                          </div>
                        </div>

                        <div className="job-meta">
                          Last posted: {formatDate(job.createdAt)}
                        </div>
                      </div>

                      <div className="job-actions">
                        <button
                          onClick={() => openJobModal(job)}
                          className="btn btn-ghost btn-sm"
                        >
                          <Eye className="action-icon" />
                        </button>

                        <button
                          onClick={() => handleRepost(job)}
                          className="btn btn-ghost btn-sm repost-btn"
                        >
                          <Copy className="action-icon" />
                          Repost
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Job Details Modal */}
      {showJobModal && selectedJob && (
        <div className="modal-overlay" onClick={() => setShowJobModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Job Details - {selectedJob.professionName}</h3>
              <button
                onClick={() => setShowJobModal(false)}
                className="modal-close"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="grid grid-2">
                <div className="detail-section">
                  <h4>Professional Details</h4>
                  <div className="detail-list">
                    <div className="detail-item">
                      <span className="detail-label">Branch:</span>
                      <span>{selectedJob.hospitalName}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Department:</span>
                      <span>{selectedJob.departmentName}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Profession:</span>
                      <span>{selectedJob.professionName}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Qualification:</span>
                      <span>{selectedJob.qualificationName}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Specialization:</span>
                      <span>{selectedJob.specializationName}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Experience:</span>
                      <span>{selectedJob.experienceName}</span>
                    </div>
                  </div>
                </div>
                <div className="detail-section">
                  <h4>Shift Details</h4>
                  <div className="detail-list">
                    <div className="detail-item">
                      <span className="detail-label">Rate:</span>
                      <span>₹ {selectedJob.rateOffered}/hour</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Duration:</span>
                      <span>{selectedJob.duration} hours</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Camp Duty:</span>
                      <span>{selectedJob.campDuty ? "Yes" : "No"}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Shift In-Charge: </span>
                      <span>
                        {" "}
                        {selectedJob.pocDetails?.split(" (")[0]}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {selectedJob.jobDescription && (
                <div className="detail-section full-width">
                  <h4>Job Description</h4>
                  <div className="job-description">
                    <ReactMarkdown>
                      {(() => {
                        try {
                          const parsed = JSON.parse(selectedJob.jobDescription);
                          const formattedDescription = parsed
                            .replace(/•/g, "-") // replace bullets
                            .replace(/\n(?=[^-])/g, "\n\n"); // extra spacing for paragraph separation

                          return (
                            formattedDescription || selectedJob.jobDescription
                          );
                        } catch {
                          return selectedJob.jobDescription;
                        }
                      }
                      )()}
                    </ReactMarkdown>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PostedJobsHistory;
